class PartnersMap {
    render() {
        const mapMarkers = [
            {
                lat: '55.555982',
                lng: '38.615319',
                title: 'Company Name1',
                phone: '+79 458 620 326',
                email: 'mail@mail.com',
                address: 'Address Line, building & number',
                marker: '/src/img/marker.png',
                type: 'violet',
            },
            {
                lat: '55.155982',
                lng: '39.815319',
                title: 'Company Name2',
                phone: '+79 458 620 326',
                email: 'mail@mail.com',
                address: 'Address Line, building & number',
                marker: '/src/img/marker-orange.png',
                type: 'orange',
            },
            {
                lat: '55.855982',
                lng: '40.815319',
                title: 'Company Name3',
                phone: '+79 458 620 326',
                email: 'mail@mail.com',
                address: 'Address Line, building & number',
                marker: '/src/img/marker.png',
                type: 'violet',
            },
            {
                lat: '56.155982',
                lng: '41.815319',
                title: 'Company Name4',
                phone: '+79 458 620 326',
                email: 'mail@mail.com',
                address: 'Address Line, building & number',
                marker: '/src/img/marker-orange.png',
                type: 'orange',
            },
            {
                lat: '55.355982',
                lng: '42.815319',
                title: 'Company Name6',
                phone: '+79 458 620 326',
                email: 'mail@mail.com',
                address: 'Address Line, building & number',
                marker: '/src/img/marker.png',
                type: 'violet',
            },
            {
                lat: '55.755982',
                lng: '37.615319',
                title: 'Evraz Steel Box',
                phone: '+79 458 620 326',
                email: 'info@evrazsteelbox.ru',
                address: 'Address Line, building & number',
                marker: '/src/img/marker.png',
                type: 'violet',
            },
            {
                lat: '55.155982',
                lng: '36.615319',
                title: 'Company Name5',
                phone: '+79 458 620 326',
                email: 'info@evrazsteelbox.ru',
                address: 'Address Line, building & number',
                marker: '/src/img/marker-orange.png',
                type: 'orange',
            }
        ]
        let mapCenter = [55.755, 39.60]
        if (window.matchMedia("(min-width: 992px)").matches) {
            mapCenter = [55.755, 39.60]
        }
        if(typeof ymaps !== 'undefined'){
            ymaps.ready(function (){
                const map = new ymaps.Map("partners_map", {
                    center: mapCenter,
                    zoom: 8
                });
                mapMarkers.forEach(marker => {
                    let myPlacemark = new ymaps.Placemark([marker.lat, marker.lng], {
                            balloonContentHeader: '<span class="marker__title">'+ marker.title +'</span>',
                            balloonContentBody: '<a href="tel:'+ marker.phone +'" class="marker__link">'+ marker.phone +'</a><a href="mailto:'+ marker.email +'" class="marker__link">'+ marker.email +'</a>',
                            balloonContentFooter: '<span class="marker__text">'+ marker.address +'</span>',
                        }
                        , {
                            draggable: false,
                            hideIconOnBalloonOpen: false,
                            preset: 'islands#whiteStretchyIcon',
                            iconLayout: 'default#image',
                            iconImageHref: marker.marker,
                            iconImageSize: [135, 140],
                            iconImageOffset: [-62, -88],
                        });
                    map.geoObjects.add(myPlacemark);
                })
            })
        }
    }
}

export default PartnersMap